import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { STRATEGIES_QUERY_KEY } from "./useStrategies";

type CreateStrategyBody = components["schemas"]["CreateStrategyBody"];
type StrategyResponse = components["schemas"]["StrategyResponse"];

export function useCreateStrategy() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<StrategyResponse, Error, CreateStrategyBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/strategies", { body });
      if (error !== undefined) {
        throw new Error("Failed to create strategy");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: STRATEGIES_QUERY_KEY });
    },
  });
}
